import mutations, { getDefaultState } from './mutations'
import actions from './actions'

export const regraPrestadorServico = {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions
}
